const errors = {
  401: 'Час вашої сесії минув. Будь ласка авторизуйтесь',
  403: 'Запис на прийом вже скасовано або скасування заборонено',
  429: 'Ви відправляєте заявки занадто часто.',
  500: 'Помилка. Спробуйте ще раз пізніше.',
  504: 'Час запиту минув. Перезавантажте цю сторінку',
};

export default errors;
